import React, {Component} from 'react';

import ('./PartnerPage.css');

class PartnerPage extends Component {


    render() {
        return (
            <section className="container-fluid">
                <div className="row partner-page">
                    <div className="partner-page-header px-4 py-lg-3 py-1">
                        <h2> We are looking for partners / investors across Europe</h2>
                    </div>
                    <div className="partner-page-content p-lg-5 px-4">
                        <p>
                            We need support from different locations across Europe to increase the use of free
                            classified ads in your own country. We're only launching it in the UK right now.
                            It will soon be launched in different European countries.
                            <br/>
                            Contact us on <a
                            href="mailto:eubines@gmail.com?subject = Want to become partner&body = Hi ">eubines@gmail.com</a>
                        </p>
                        <div className="email-btn">
                            <a href="mailto:eubines@gmail.com?subject=Want to become partner&body=Hi">
                                <span className="btn btn-grad btn-md btn-outline-secondary">Send Email</span>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

}


export default PartnerPage;



// WEBPACK FOOTER //
// ./src/Pages/PartnerPage.js